module.exports = __webpack_public_path__ + "static/mity-o-crm-2cbcdbe0195a8eb016eacfe6f501644e.png";